import React, { useEffect, useState } from "react";

import { Route, Switch, Redirect, withRouter } from "react-router-dom";

import Landing from "../Screens/Landing/Landing";
import Profile from "../Screens/Profile/Profile";
import Search from "../Screens/Search/Search";
import Dashboard from "../Screens/Dashboard/Dashboard";
import Support from "../Screens/Support/Support";
import Applications from "../Screens/Applications/Applications";
import ApplicationEdit from "../Screens/Applications/ApplicationEdit";
import ApplicationCreate from "../Screens/Applications/ApplicationCreate";
import ApplicationStatistics from "../Screens/Applications/ApplicationStatistics";
import Learn from "../Screens/Learn/Learn";
import Login from "../Screens/Login/Login";
import Logout from "../Screens/Login/Logout";
import Pricing from "../Screens/Pricing/Pricing";
import Documentation from "../Screens/Documentation/Documentation";
import CSharp from "../Screens/Documentation/CSharp";
import Web from "../Screens/Documentation/Web";
import Node from "../Screens/Documentation/Node";
import IOS from "../Screens/Documentation/IOS";
import Android from "../Screens/Documentation/Android";
import ReactNative from "../Screens/Documentation/ReactNative";
import Apis from "../Screens/Documentation/APIS";
import Store from "../Screens/Store/Store";
import Billing from "../Screens/Billing/Billing";
import SandBox from "../Screens/SandBox/SandBox";
import SandBoxProfile from "../Screens/SandBox/SandBoxProfile";
import LoginSso from "../Screens/Login/LoginSso";
import PageNotFound from "../Screens/ErrorPage/PageNotFound";

import * as Path from "../Constants/GlobalConstant";
import * as ContactUtils from "../Utils/ContactUtils";

import LogService from "../../middleware/CommonSdk/LogService";
import PropTypes from "prop-types";

const LOG_TAG = "ROUTING_CONTENT";

const Routing = (props) => {
    const basicRoutes = [
        <Route key="route_1" path={Path.SEARCH_PATH} component={Search} />,
        <Route key="route_2" path={Path.DOC_PATH} component={Documentation} />,
        <Route key="route_4" path={Path.CSHARP_PATH} component={CSharp} />,
        <Route key="route_5" path={Path.WEB_PATH} component={Web} />,
        <Route key="route_6" path={Path.NODE_PATH} component={Node} />,
        <Route key="route_7" path={Path.IOS_PATH} component={IOS} />,
        <Route key="route_8" path={Path.ANDROID_PATH} component={Android} />,
        <Route key="route_9" path={Path.REACTNATIVE_PATH} component={ReactNative} />,
        <Route key="route_10" path={Path.APIS_PATH} component={Apis} />,
        <Route key="route_11" path={Path.LOGIN_PATH} component={Login} />,
        <Route key="route_12" path={Path.SSO_PATH} component={LoginSso} />,
        <Route key="route_13" path={Path.LOGOUT_PATH} component={Logout} />,
        <Route key="route_14" path={Path.LEARN_PATH} component={Learn} />,
        <Route key="route_15" path={Path.PRICING_PATH} component={Pricing} />,
        <Route key="route_16" path={Path.HOME_PATH} component={Landing} />,
        <Route key="route_17" path={Path.STORE_PATH} component={Store} />,
        <Route key="route_18" path={Path.SUPPORT_PATH} component={Support} />
    ];
    const [routingTable, setRoutingTable] = useState([]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect user");

        let routes = [...basicRoutes];

        if (props.user) {//is authenticated
            const isDeveloper = ContactUtils.isDeveloper(props.user);
            const isSuperAdmin = ContactUtils.isSuperAdminOrAppSuperAdmin(props.user);
            const isSupport = ContactUtils.isSupportOrAppSupport(props.user);
            if (isDeveloper) {
                routes.push(...[
                    <Route key="route_19" path={Path.APPLICATIONS_PATH} component={Applications} />,
                    <Route key="route_20" path={Path.APPLICATION_PATH + Path.CREATE_PATH} component={ApplicationCreate} />,
                    <Route key="route_21" path={Path.APPLICATION_PATH + Path.STATISTICS_PATH} component={ApplicationStatistics} />,
                    <Route key="route_22" path={Path.APPLICATION_PATH + Path.EDIT_PATH} component={ApplicationEdit} />,
                    <Route key="route_23" path={Path.BILLING_PATH} component={Billing} />,
                    <Route key="route_24" path={Path.SANDBOX_PATH + Path.PROFILE_PATH} component={SandBoxProfile} />,
                    <Route key="route_25" path={Path.SANDBOX_PATH} component={SandBox} />,
                ]);
            }
            if (isSuperAdmin) {
                const routesToAdd = [
                    <Route key="route_19" path={Path.APPLICATIONS_PATH} component={Applications} />,
                    <Route key="route_20" path={Path.APPLICATION_PATH + Path.CREATE_PATH} component={ApplicationCreate} />,
                    <Route key="route_21" path={Path.APPLICATION_PATH + Path.STATISTICS_PATH} component={ApplicationStatistics} />,
                    <Route key="route_22" path={Path.APPLICATION_PATH + Path.EDIT_PATH} component={ApplicationEdit} />,
                ]

                let filteredRoutesToAdd = routesToAdd.filter(item => routes.findIndex(existingRoute => existingRoute.props.path === item.props.path) < 0);
                routes.push(...filteredRoutesToAdd);
            }
            if (isSupport) {
                const routesToAdd = [
                    <Route key="route_19" path={Path.APPLICATIONS_PATH} component={Applications} />,
                    <Route key="route_21" path={Path.APPLICATION_PATH + Path.STATISTICS_PATH} component={ApplicationStatistics} />,
                    <Route key="route_22" path={Path.APPLICATION_PATH + Path.EDIT_PATH} component={ApplicationEdit} />,
                ];
                let filteredRoutesToAdd = routesToAdd.filter(item => routes.findIndex(existingRoute => existingRoute.props.path === item.props.path) < 0);
                routes.push(...filteredRoutesToAdd);
            }

            routes.push(...[
                <Route key="route_26" path={Path.DASHBOARD_PATH} component={Dashboard} />,
                <Route key="route_27" exact path={Path.ROOT_PATH} component={Dashboard} />,
                <Route key="route_28" path={Path.PROFILE_PATH} component={Profile} />
            ]);
        } else {
            routes.push(
                <Route key="route_27" exact path={Path.ROOT_PATH} component={Landing} />
            );
        }

        if (props.isInitialLoadFinished) {
            if (props.user == null || ContactUtils.isUserFullyLoaded(props.user)) {
                LogService.debug(LOG_TAG, "add not found");
                routes.push(
                    <Route key="route_99" render={() => {
                        LogService.error(LOG_TAG, "route not found", props.location.pathname);
                        let component = <PageNotFound />;
                        if (props.user == null) {//not logged-in
                            switch (props.location.pathname) {
                                case Path.DASHBOARD_PATH:
                                case Path.PROFILE_PATH:
                                case Path.APPLICATIONS_PATH:
                                case Path.BILLING_PATH:
                                case Path.SANDBOX_PATH:
                                    component = <Redirect to={Path.HOME_PATH} />;
                                    break;
                                default:
                                    if (props.location.pathname.startsWith(Path.APPLICATION_PATH))
                                        component = <Redirect to={Path.HOME_PATH} />;
                                    break;
                            }
                        }
                        return component;
                    }} />
                );
            }
        }

        setRoutingTable(routes);
    }, [props.user, props.isInitialLoadFinished]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect location");

        //compatibility : handle hashroute for documentation (pathname = "/" hash="#/documentation/...")
        if (props.location.pathname === Path.ROOT_PATH && props.location.hash.length > 0 && props.location.hash.startsWith("#/documentation")) {
            let url = props.location.hash.substring(15);
            LogService.warn(LOG_TAG, "useEffect location: redirect hash route for documentation to:", url);
            props.history.replace(url)
        }
    }, [props.location.hash]);

    LogService.trace(LOG_TAG, "render");
    return (<Switch>{routingTable}</Switch>);
}

Routing.propTypes = {
    user: PropTypes.object,
    isInitialLoadFinished: PropTypes.bool,
};

Routing.defaultProps = {
    user: null,
    isInitialLoadFinished: false
}

export default withRouter(Routing);